import React, { ChangeEvent, FormEvent, useState } from "react";
import { Box } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { fetchPermissions, invokeLogin } from "../api-client/client";
import Typography from "@material-ui/core/Typography";
import ErrorMessage from "../components/ErrorMessage";

interface LoginPageProps {
    login: (permissions: string[]) => void
}

const LoginPage: React.FC<LoginPageProps> = (props) => {
    const { login } = props;
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loginErrorMsg, setLoginErrorMsg] = useState<string|null>();
    const [usernameError, setUsernameError] = useState<string|null>();
    const [passwordError, setPasswordError] = useState<string|null>();

    const submitLoginData = (e: FormEvent) => {
        e.preventDefault();
        if (!validate()) {
            return;
        }

        const data = new FormData();
        data.append('username', username);
        data.append('password', password);

        invokeLogin(data).then(() => {
            fetchPermissions().then(permissions => {
                login(permissions);
            });
        }).catch(e => {
            setLoginErrorMsg(e.statusCode === 401 ?
                "Invalid username or password" : e.message);
        });
    };

    const validate = () => {
        const usernameValid = validateUserName(username);
        const passwordValid = validatePassword(password);
        return usernameValid && passwordValid;
    };

    const validateUserName = (username: string) => {
        const isValid = username.trim().length > 0;
        setUsernameError(isValid ? null : "Required");
        return isValid;
    };

    const validatePassword = (password: string) => {
        const isValid = password.trim().length > 0;
        setPasswordError(isValid ? null : "Required");
        return isValid;
    };

    const usernameChanged = (e: ChangeEvent<HTMLInputElement>) => {
        setUsername(e.target.value);
        validateUserName(e.target.value);
        setLoginErrorMsg(null);
    };

    const passwordChanged = (e: ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value);
        validatePassword(e.target.value);
        setLoginErrorMsg(null);
    };

    return(
        <Box mt={4}>
            <Paper>
                <form autoComplete="off" onSubmit={submitLoginData} noValidate>
                    <Box pt={4} display="flex" justifyContent="center" alignItems="center" flexDirection="column" flexWrap="column">
                        <Box>
                            <Typography component="h2" variant="h5" color="primary" gutterBottom>
                                Login
                            </Typography>
                        </Box>
                        <Box mt={1} mb={1}>{loginErrorMsg && <ErrorMessage message={loginErrorMsg}/>}</Box>
                        <Box pb={3}>
                            <Box><TextField id="username" error={usernameError != null} helperText={usernameError ? usernameError : " "} required label="Username" type="text" onChange={usernameChanged} /></Box>
                            <Box mt={1}><TextField id="password" error={passwordError != null} helperText={passwordError ? passwordError : " "} required label="Password" type="password" onChange={passwordChanged} /> </Box>
                        </Box>
                        <Box pb={3}>
                            <Button variant="contained" color="primary" type="submit" onSubmit={submitLoginData} data-testid="login-btn">
                                Login
                            </Button>
                        </Box>
                    </Box>
                </form>
            </Paper>
        </Box>
    )
};


export default LoginPage;